// extracted by mini-css-extract-plugin
export default {"featureHeader":"FeatureHeader_featureHeader__7Mqyi","center":"FeatureHeader_center__ZR3-w","featureHeaderImg":"FeatureHeader_featureHeaderImg__gdZtP"};